import 'react-clock/dist/Clock.css';
import 'react-time-picker/dist/TimePicker.css';
import styled from 'styled-components';

export const TimeSlotInputStyle = styled.div``;

export const TimeStyle = styled.div`
  .react-time-picker__wrapper {
    box-sizing: border-box;
    height: 47px;
    border: 1px solid ${({ theme }) => theme.palette.divider};
    border-radius: 7px;
    background-color: ${({ theme }) => theme.palette.background.default};
    padding: 10px;
    margin: 5px 0;
    width: 157px;

    ${(props) => props.theme.breakpoints.down('sm')} {
      background-color: ${({ theme }) => theme.palette.background.paper};
    }
  }

  &.error {
    border-radius: 7px;
    border: 1px solid ${({ theme }) => theme.palette.error.main};
    background-color: ${({ theme }) => theme.palette.background.paper};
  }

  .react-time-picker__inputGroup__input {
    height: auto;
  }
`;

export const ErrorMessage = styled.p`
  color: ${({ theme }) => theme.palette.error.main};
  font-size: 12px;
  margin: -6px 8px 0;
`;

export const SlotsWrapper = styled.div`
  padding-left: 10px;
`;
export const SlotWrapper = styled.div`
  padding-left: 10px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
`;
